import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { showNotification } from '@epi-actions/overlays';
import emptyApi from '@epi-api/emptyApi';
import { get } from '@epi-helpers/FetchHelpers';
import { VoucherOrderHistory } from '@epi-models/pages/PaperVouchers';

import config from '../../config/config';

export const getVoucherOrders = async (): Promise<VoucherOrderHistory> =>
  get<VoucherOrderHistory>(`${config.apiHost}/api/voucher-orders`);

export const vouchersApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    hasVoucherOrders: build.query<boolean, void>({
      async queryFn(_arg, api) {
        try {
          const data = await getVoucherOrders();
          return { data: data.voucherOrders.length > 0 };
        } catch (error) {
          api.dispatch(
            showNotification({ message: 'messages.error' }, 'error')
          );
          return { error: error as FetchBaseQueryError };
        }
      },
      keepUnusedDataFor: 0
    })
  })
});

export const { useHasVoucherOrdersQuery } = vouchersApi;
